// Actions
import { ProductActions, ProductActionTypes } from './product.actions';

// Models
import { ProductState } from './product.state';

const defaultState: ProductState = {
    loading: false,
    totalPrice: undefined,
    alternativeProducts: [],
    error: '',
};

export type Action = ProductActions;

export function ProductReducer(state = defaultState, action: any) {
    switch (action.type) {
        case ProductActionTypes.DO_GET_TOTAL_PRICE:
            return {
                ...state,
                loading: true,
                error: '',
                products: undefined,
            };

        case ProductActionTypes.DO_GET_TOTAL_PRICE_OK:
            return {
                ...state,
                loading: false,
                products: [...action.payload],
            };

        case ProductActionTypes.DO_GET_TOTAL_PRICE_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                products: undefined,
            };

        case ProductActionTypes.DO_GET_ALTERNATIVE_PRODUCTS:
            return {
                ...state,
                loading: true,
                error: '',
            };

        case ProductActionTypes.DO_GET_ALTERNATIVE_PRODUCTS_OK:
            return {
                ...state,
                loading: false,
                alternativeProducts: [...action.payload],
            };

        case ProductActionTypes.DO_GET_ALTERNATIVE_PRODUCTS_KO:
            return {
                ...state,
                loading: false,
                error: action.payload,
                alternativeProducts: undefined,
            };
        default:
            return state;
    }
}
